import keyBy from "lodash.keyby";
import groupBy from "lodash.groupby";

/** Build a record from an array */
export const buildRecords = <TValue>(array: TValue[], indexAccessor: (item: TValue) => PropertyKey): Record<PropertyKey, TValue> => keyBy(array, indexAccessor) as Record<PropertyKey, TValue>;

/** Build a lookup from an array */
export const buildLookup = <TKey extends keyof any, TValue>(array: TValue[], indexAccessor: (item: TValue) => TKey): Record<TKey, TValue[]> => groupBy(array, indexAccessor) as Record<TKey, TValue[]>;
